import { FileImageOutlined } from '@ant-design/icons'
import { Checkbox } from 'antd'
import { object } from 'prop-types'
import React from 'react'

import FileUpload from 'components/fileUpload'

import { FormItem, styleIconValidation } from './base/styles'
import { Widget, useUpdate, useValidation } from './base/widget'
import { CommonFields } from './base/widgetCommonFields'

export const AttachmentWidget = React.memo((props) => {
	const { data } = props

	const update = useUpdate(props)
	const [valid, setValid] = useValidation(props)

	return (
		<Widget
			{...props}
			type={'Upload de Anexo'}
			icon={<Icon $error={!valid} />}
			onValidate={setValid}
			displayStyles={null}
			formItems={
				<div>
					<CommonFields data={data} update={update} />

					<FormItem
						label="Permitir múltiplos arquivos"
						$labelWidth="180px"
						style={{ alignItems: 'center' }}>
						<Checkbox
							checked={data.multiple ?? false}
							onChange={(e) => update({ multiple: e.target.checked })}
						/>
					</FormItem>
					<FormItem label="Documento inicial" $labelWidth="180px">
						<FileUpload
							initialValue={data.initialValue}
							onChange={(v) => {
								update({ initialValue: v ?? [] })
							}}
							multiple={data.multiple}
						/>
					</FormItem>
				</div>
			}
		/>
	)
})

const Icon = styleIconValidation(FileImageOutlined)

AttachmentWidget.propTypes = {
	data: object,
}
